import { createStructuredSelector } from 'reselect'

const initialState = {
  tableParams: {},
  isModalOpen: false,
  selectedBatteries: [],
  selectedRow: [],
  auxiliarSelectedRow: null,
  hideActionBar: false
}

export const deletedBatteriesDetailsReducer = (state = initialState, { payload, type } = {}) => {
  switch (type) {
    case setTableParams.type:
      return {
        ...state,
        tableParams: payload
      }
    case setModalIsOpen.type:
      return {
        ...state,
        isModalOpen: payload
      }
    case setSelectedBatteries.type:
      return {
        ...state,
        selectedBatteries: payload
      }
    case setSelectedRow.type:
      return {
        ...state,
        selectedRow: payload
      }
    case setHideActionBar.type:
      return {
        ...state,
        hideActionBar: payload
      }
    case setAuxiliarSelectedRow.type:
      return {
        ...state,
        auxiliarSelectedRow: payload
      }
    case resetTableSelection.type:
      return {
        ...state,
        isModalOpen: false,
        selectedRow: [],
        auxiliarSelectedRow: [],
        hideActionBar: true
      }
    default:
      return state
  }
}
deletedBatteriesDetailsReducer.slice = 'deleted-batteries-details'

export const setTableParams = (tableParams = {}) => ({ type: setTableParams.type, payload: tableParams })
setTableParams.type = 'deleted-batteries-details/setTableParams'

export const setModalIsOpen = (isModalOpen = false) => ({ type: setModalIsOpen.type, payload: isModalOpen })
setModalIsOpen.type = 'deleted-batteries-details/setModalIsOpen'

export const setSelectedBatteries = (selectedBatteries = []) => ({ type: setSelectedBatteries.type, payload: selectedBatteries })
setSelectedBatteries.type = 'deleted-batteries-details/setSelectedBatteries'

export const setSelectedRow = (selectedRow = []) => ({ type: setSelectedRow.type, payload: selectedRow })
setSelectedRow.type = 'deleted-batteries-details/setSelectedRow'

export const setAuxiliarSelectedRow = (auxiliarSelectedRow = []) => ({ type: setAuxiliarSelectedRow.type, payload: auxiliarSelectedRow })
setAuxiliarSelectedRow.type = 'deleted-batteries-details/setAuxiliarSelectedRow'

export const setHideActionBar = (hideActionBar = false) => ({ type: setHideActionBar.type, payload: hideActionBar })
setHideActionBar.type = 'deleted-batteries-details/setHideActionBar'

export const resetTableSelection = () => ({ type: resetTableSelection.type })
resetTableSelection.type = 'deleted-batteries-details/resetTableSelection'

export const getTableParams = state => state[deletedBatteriesDetailsReducer.slice].tableParams
export const getModalIsOpen = state => state[deletedBatteriesDetailsReducer.slice].isModalOpen
export const getSelectedBatteries = state => state[deletedBatteriesDetailsReducer.slice].selectedBatteries
export const getSelectedRow = state => state[deletedBatteriesDetailsReducer.slice].selectedRow
export const getAuxiliarSelectedRow = state => state[deletedBatteriesDetailsReducer.slice].auxiliarSelectedRow
export const getHideActionBar = state => state[deletedBatteriesDetailsReducer.slice].hideActionBar

export const getDetailsDataTableSelectors = createStructuredSelector({
  tableParams: getTableParams,
  isModalOpen: getModalIsOpen,
  selectedBatteries: getSelectedBatteries,
  selectedRow: getSelectedRow,
  auxiliarSelectedRow: getAuxiliarSelectedRow,
  hideActionBar: getHideActionBar
})
